







































import Component from 'vue-class-component';
import Vue from 'vue';

@Component
export default class CharacterOverview extends Vue {
  get characters() {
    return [
      {
        name: 'Idanto Corelli',
        class: 'Scioppo Incanto',
        id: 'aaaaa',
        level: 25,
      },
      {
        name: 'Dante Salviati',
        class: 'Harpye',
        id: 'bbbb',
        level: 24,
      },
    ];
  }

  public navigateToCharacter(id) {
    this.$router.push('/character/' + id);
  }

  public createCharacter() {
    this.$router.push('/character');
  }
}
